import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_entity_spending_limit_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  limit_status: fromDatatype.VarcharDatatypeInterface;
  qty_quota: fromDatatype.NumericDatatypeInterface;
  amount_quota: fromDatatype.NumericDatatypeInterface;
  qty_usage: fromDatatype.NumericDatatypeInterface;
  amount_usage: fromDatatype.NumericDatatypeInterface;
  rolling_duration_in_day: fromDatatype.IntegerDatatypeInterface;
  is_enabled: boolean;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config :fromDatatype.JsonDatatypeInterface;
  acl_policy :fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  branch_label_link_guid:  fromDatatype.GuidDataFieldInterface;
}
export class bl_fi_mst_entity_spending_limit_line_RowClass
  implements bl_fi_mst_entity_spending_limit_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    limit_status: fromDatatype.VarcharDatatypeInterface;
    qty_quota: fromDatatype.NumericDatatypeInterface;
    amount_quota: fromDatatype.NumericDatatypeInterface;
    qty_usage: fromDatatype.NumericDatatypeInterface;
    amount_usage: fromDatatype.NumericDatatypeInterface;
    rolling_duration_in_day: fromDatatype.IntegerDatatypeInterface;
    is_enabled: boolean;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config :fromDatatype.JsonDatatypeInterface;
    acl_policy :fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:  fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    branch_label_link_guid:  fromDatatype.GuidDataFieldInterface;
}
